import { useForm } from "react-hook-form";
import { WebUser } from "../../../models/WebUser";
import { useDispatch } from "react-redux";
import {setErrors, setSuccessMessage} from "../../../store/alerts/alertsActions";
import getInputError from "../../../messages/inputsValidation";
import useApiRequest from "../../../utils/hook/useApiRequest";
import { REGISTER_WEBUSER } from "../../../api/apiRoutes";

export default function useRegistration(onClose: () => void) {
  const { register, errors, watch } = useForm<any>({
    defaultValues: {} as WebUser,
    mode: "onBlur",
  });

  const webUserData = watch();
  const dispatch = useDispatch();
  const { post } = useApiRequest();

  const onSubmit = async () => {
    if (
      webUserData.email === "" ||
      webUserData.repeatEmail === "" ||
      webUserData.password === "" ||
      webUserData.reapeatPassword === "" ||
      webUserData.firstName === "" ||
      webUserData.lastName === "" ||
      webUserData.phone === ""
    ) {
      dispatch(setErrors(["Uzupełnij wymagane pola"]));
      return;
    }

    if (webUserData.email !== webUserData.repeatEmail) {
      dispatch(setErrors(["Podane adresy email są różne"]));
      return;
    }

    if (webUserData.password !== webUserData.reapeatPassword) {
      dispatch(setErrors(["Podane hasła są różne"]));
      return;
    }

    if (errors.email) {
      dispatch(setErrors([getInputError(errors, "email")]));
      return;
    }
    if (errors.password) {
      dispatch(setErrors([getInputError(errors, "password")]));
      return;
    }
    if (errors.phone) {
      dispatch(setErrors([getInputError(errors, "phone")]));
      return;
    }

    const { isError } = await post(REGISTER_WEBUSER, webUserData);
    if (!isError) {
        dispatch(setSuccessMessage("Na podany e-mail została wysłana wiadomość z linkiem aktywacyjnym"));
        onClose();
    }
  };

  return {
    register,
    errors,
    onSubmit,
    webUserData,
  };
};
